import { dialogEngine, dialogWebviewEngine, pollEngine, SchemaEngine, webviewEngine } from 'schema/adminEngine';
import { SimpleEngine } from '../types/pollTypes';

export function getEngine(template: typeof TEMPLATE_DIALOG | typeof TEMPLATE_DIALOG_WEBVIEW): typeof dialogEngine;
export function getEngine(template: typeof TEMPLATE_WEBVIEW): typeof webviewEngine;
export function getEngine(template: 'poll'): SimpleEngine;
export function getEngine(template?: string): SchemaEngine;
export function getEngine(template?: string): any {
  switch (template) {
    case TEMPLATE_DIALOG:
      return dialogEngine;
    case TEMPLATE_DIALOG_WEBVIEW:
      return dialogWebviewEngine;
    case TEMPLATE_WEBVIEW:
      return webviewEngine;
    default:
      return pollEngine;
  }
}

export const TEMPLATE_POLL = 'poll';
export const TEMPLATE_DIALOG = 'dialog';
export const TEMPLATE_WEBVIEW = 'webview';
export const TEMPLATE_DIALOG_WEBVIEW = 'dialog_webview';
